import React from "react";
import Banner from "../components/banner.components";
import Category from "../components/category.components";
import Discount from "../components/discount.componets";
import Footer from "../components/footer.componets";
import Instagram from "../components/instagram.componets";
import Product from "../components/product.componets";
import Service from "../components/service.componets";
import Trend from "../components/trend.components";
const Home = () => {
  return (
    <div className="home-container">
      {/* <!-- Page Preloder --> */}
      {/* <div id="preloder">
        <div className="loader"> loader</div>
      </div> */}

      {/* <!-- Offcanvas Menu Begin --> */}
      {/* <div className="offcanvas-menu-overlay"></div> */}

      {/* navigation  */}
      {/* <!-- Header Section End --> */}
     
      {/* <!-- Categories Section Begin --> */}
            <Category/>
      {/* <!-- Categories Section End --> */}

      {/* <!-- Product Section Begin --> */}
      <section className="product spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-4">
              <div className="section-title">
                <h4>New product</h4>
              </div>
            </div>
            <div className="col-lg-8 col-md-8">
              <ul className="filter__controls">
                <li className="active" data-filter="*">
                  All
                </li>
                <li data-filter=".women">Women’s</li>
                <li data-filter=".men">Men’s</li>
                <li data-filter=".kid">Kid’s</li>
                <li data-filter=".accessories">Accessories</li>
                <li data-filter=".cosmetic">Cosmetics</li>
              </ul>
            </div>
          </div>
         <Product/>
        </div>
      </section>
      {/* <!-- Product Section End --> */}

      {/* <!-- Banner Section Begin --> */}
          <Banner/>
      {/* <!-- Banner Section End --> */}

      {/* <!-- Trend Section Begin --> */}
     <Trend/>
      {/* <!-- Trend Section End --> */}

      {/* <!-- Discount Section Begin --> */}
     <Discount/>
      {/* <!-- Discount Section End --> */}

      {/* <!-- Services Section Begin --> */}
      <Service/>
      {/* <!-- Services Section End --> */}

      {/* <!-- Instagram Begin --> */}
     <Instagram/>

      <Footer />
      {/* <!-- Instagram End --> */}
    </div>
  );
};

export default Home;
